import React, { useMemo, useState } from 'react';
import BasicButton from './BasicButton';
import TextInput from './TextInput';
import { useSelector } from 'react-redux';
import { useMutationQuery } from 'Api/hooks/useMutationQuery';
import { useError } from 'Api/hooks/useError';
import { useIntl } from 'react-intl';

const PasswordForm = ({ onCompleted, businessNumber, managerPhone, otpCode }) => {
  const { showErrorPopup } = useError();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { country } = useSelector(state => state.settings);
  const phoneCountry = useMemo(() => (country === 'ko' ? '82' : '84'), [country]);
  const { formatMessage } = useIntl();
  const { mutate } = useMutationQuery({
    method: 'post',
    url: '/auth/findPassword',
    options: {
      onSuccess: () => {
        onCompleted();
      },
      onError: error => {
        showErrorPopup({ text: error?.response?.data?.message });
      },
    },
  });

  const isDisabled = useMemo(() => {
    if (password.length < 6 || password.length > 15) return true;
    if (password !== confirmPassword) return true;
    return false;
  }, [password, confirmPassword]);

  const handleChangePassword = () => {
    mutate({ otpCode, phoneCountry, businessNumber, managerPhone, password });
  };

  return (
    <>
      <div className="form-container">
        <TextInput
          isError={password !== '' && (password.length < 6 || password.length > 15)}
          errorText={formatMessage({ id: 'error.password.validate' })}
          name="password"
          label="common.password"
          placeholder="sign.password.message"
          value={password}
          onChange={e => {
            setPassword(e.target.value);
          }}
          isPassword
          tabIndex={4}
        />
        <TextInput
          isError={confirmPassword !== '' && confirmPassword !== password}
          errorText={formatMessage({ id: 'error.password.notMatch' })}
          name="confirmPassword"
          label="common.password2"
          value={confirmPassword}
          onChange={e => {
            setConfirmPassword(e.target.value);
          }}
          isPassword
          tabIndex={5}
        />
      </div>
      <BasicButton label="common.done" onClick={handleChangePassword} style={{ backgroundColor: '#0567F9' }} disabled={isDisabled} />
    </>
  );
};

export default PasswordForm;
